import apiClient from './apiClient';

const orderService = {
  getAll: async (params = {}) => {
    const response = await apiClient.get('/orders', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/orders/${id}`);
    return response.data;
  },

  updateStatus: async (id, status) => {
    const response = await apiClient.put(`/orders/${id}`, { status });
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/orders/${id}`);
    return response.data;
  }
};

export default orderService;
